import { Component, computed, EventEmitter, inject, Input, input, Output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { SearchMedicalProcedureStore } from './search-medical-procedure.store';
import { MedicalProcedureObject } from '@it2go/types';
import { InfiniteScrollStore } from '../../../../shared/store/common/infinite-scroll.store';
import { FilterBuilder } from '../../../helper/filter.builder';
import { routeParams } from '../../../../shared/shared.global-service';
import { getExpertisesFrag } from './search-medical-procedure.query';
import { tableImports } from '../../../../shared/components/kit/table/table.component';
import { Chip } from '@openng/optimus-ui/chip';
import { StripAndShowComponent } from '../../../../shared/components/kit/strip-and-show/strip-and-show.component';

@Component({
    selector: 'app-search-medical-procedure',
    templateUrl: 'search-medical-procedure.component.html',
    styleUrls: ['search-medical-procedure.component.scss'],
    providers: [SearchMedicalProcedureStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        tableImports,
        Chip,
        StripAndShowComponent,
    ],
})
export class SearchMedicalProcedureComponent extends SubscriptionComponent {

    protected readonly store = inject(SearchMedicalProcedureStore);

    public form = input.required<FormGroup<{ expertiseCodes: any }>>();
    @Input() id = 'procedures';
    @Input() label = '';
    @Input() serviceId: number | null = null;

    @Output() selected = new EventEmitter<MedicalProcedureObject>();

    protected expertises = computed(() => {
        const expertises: { code: string }[] = [...(this.store.data.getExpertises()?.items || [])];
        // On demand added expertises that are not of allowed services, but their procedures are required
        const codesToAdd = [606, 701, 706, 708, 710, 911, 958, 999];
        expertises.push(...codesToAdd.map(it => ({ code: String(it) })));
        expertises.sort((a, b) => a.code.localeCompare(b.code));
        return expertises;
    });

    protected expertisesChange = signal<string[]>([]);

    protected procedureScroll = computed(() => {
        const filter = FilterBuilder.where({
            limit: 500,
            notInService: routeParams.serviceId(),
        });
        const expertises = this.expertisesChange();
        if (expertises.length) {
            filter.where('expertiseCode', expertises);
        }

        return new InfiniteScrollStore(
            this.store.api.getMedicalProcedures,
            filter.filter(),
            true,
            undefined,
            undefined,
            true,
            'code',
        );
    });

    constructor() {
        super();
        this.store.api.getExpertises(FilterBuilder.singlePage(), getExpertisesFrag).then();
    }

}
